// Live Search Component
export const MESSAGE = "Searching...";

export default {
  MESSAGE,
};
